/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useRef } from 'react';
import ImageGallery from 'react-image-gallery';
import { Box } from '@chakra-ui/react';
import Image from 'next/image';
import GalleryItem from './GalleryItem';
import { MyProjectFragment } from '@src/generated/graphql';
import 'react-image-gallery/styles/css/image-gallery.css';

type GalleryProps = Pick<MyProjectFragment, 'gallery'>;

const Gallery: React.FC<GalleryProps> = ({ gallery }) => {
  const ref = useRef<ImageGallery>(null);
  if (!gallery) return null;

  return (
    <Box
      id="photo-gallery"
      mb="50px"
      sx={{
        '& .image-gallery-icon:hover': { color: 'primary' },
        '& .image-gallery-thumbnail.active,.image-gallery-thumbnail:focus,.image-gallery-thumbnail:hover':
          {
            borderColor: 'primary',
            borderWidth: '3px',
          },
        '& .image-gallery-thumbnail-portrait': { width: '55px !important' },
      }}
    >
      {/* @ts-ignore */}
      <ImageGallery
        ref={ref}
        onClick={() => ref.current?.fullScreen()}
        items={gallery.map((img) => {
          const width = img?.asset?.metadata?.dimensions?.width ?? 200;
          const height = img?.asset?.metadata?.dimensions?.height ?? 200;
          const isPortrait = height > width;
          return {
            original: img?.asset?.url ?? '',
            thumbnail: img?.asset?.url ?? '',
            originalHeight: height,
            originalWidth: width,
            thumbnailClass: isPortrait
              ? 'image-gallery-thumbnail-portrait'
              : undefined,
            originalAlt: img?.alt ?? '',
            renderThumbInner: () => (
              <Image
                src={img?.asset?.url ?? ''}
                alt={img?.alt ?? ''}
                width={isPortrait ? 49 : 94}
                height={70}
                quality={100}
                style={{ maxWidth: '100%' }}
              />
            ),
            renderItem: (props) => (
              <GalleryItem
                {...props}
                blurData={img?.asset?.metadata?.lqip ?? ''}
                isFullScreen={
                  typeof ref?.current?.state === 'object' &&
                  'isFullscreen' in ref.current.state &&
                  !!ref.current.state.isFullscreen
                }
              />
            ),
          };
        })}
        lazyLoad
      />
    </Box>
  );
};

export default Gallery;
